import * as React from "react";
import { ChatKnowledgeBasePanel } from "./ChatKnowledgeBasePanel";
import { ChatMicroBtn } from "./ui/ChatMicroBtn";
import { IconClose } from "./icons/ChatIcons";

export type ChatKbContextModalProps = {
  open: boolean;
  onClose: () => void;
  active: boolean;
  onKbSelectedFileIdsChange: (fileIds: string[]) => void;
  onReferenceFileLabelsChange: (items: Array<{ id: string; fileName: string }>) => void;
};

export const ChatKbContextModal: React.FC<ChatKbContextModalProps> = ({
  open,
  onClose,
  active,
  onKbSelectedFileIdsChange,
  onReferenceFileLabelsChange,
}) => {
  React.useEffect(() => {
    if (!open) return undefined;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="chat-kb-modal-overlay"
      role="presentation"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="chat-kb-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Knowledge base"
      >
        <div className="chat-kb-modal__header">
          <span className="chat-kb-modal__title">Knowledge base</span>
          <ChatMicroBtn title="Close" aria-label="Close" onClick={onClose}>
            <IconClose size={14} />
          </ChatMicroBtn>
        </div>
        <div className="chat-kb-modal__body thin-scroll">
          <ChatKnowledgeBasePanel
            active={active}
            onKbSelectedFileIdsChange={onKbSelectedFileIdsChange}
            onReferenceFileLabelsChange={onReferenceFileLabelsChange}
          />
        </div>
      </div>
    </div>
  );
};
